const isInfant = errorData => errorData.isInfant === 'true'

export default {
  flightId: 'flightId',
  passengerId: 'passengerId',
  fieldName: 'fieldName',
  type: 'type',
  isInfant,
}
